/* Homepage CTA measurement — Round 2, October 25, 2026.
 * Add data-pp-home-cta="<allowed id>" to the corresponding homepage anchors.
 * This uses an existing GA4 collector only. It never loads/configures a tag,
 * sends ecommerce/page-view events, or treats a success-page view as a signup.
 * A successful gtag call is NOT proof of GA4 receipt; verify in GA4 UI.
 */
(function () {
  'use strict';

  function normalizedPath(path) {
    return (path || '/').replace(/\/+$/, '') || '/';
  }

  if (normalizedPath(window.location.pathname) !== '/') return;
  if (window.__ppHomeCtaMeasurementV1) return;
  window.__ppHomeCtaMeasurementV1 = true;

  var GA4_ID = 'G-F7VDRC4921';
  var EVENT_NAME = 'pp_home_cta_click';
  var FORM_ORIGIN = 'https://subscribe-forms.beehiiv.com';
  var FORM_PATH = '/v3/forms/0df2a8d6-3574-4f5b-a21c-79415dd5919d';
  var ALLOWED = Object.freeze({
    hero_free: { placement: 'hero', origin: FORM_ORIGIN, path: FORM_PATH },
    hero_preview: { placement: 'hero_preview', origin: FORM_ORIGIN, path: FORM_PATH },
    hero_bestsellers: { placement: 'hero', path: '/collections/teacher-bestsellers' },
    bestsellers_view_all: { placement: 'bestsellers', path: '/collections/teacher-bestsellers' },
    founder_story: { placement: 'founder', path: '/pages/about-us' },
    choice_free: { placement: 'start_here', origin: FORM_ORIGIN, path: FORM_PATH },
    choice_escape_rooms: { placement: 'start_here', path: '/collections/escape-rooms' },
    choice_full_year: { placement: 'start_here', path: '/collections/full-year-curriculum' },
    bundle_core: { placement: 'bundle_comparison', path: '/products/complete-high-school-physics-curriculum-bundle-ngss-aligned-grades-9-12' },
    bundle_plus: { placement: 'bundle_comparison', path: '/products/high-school-physics-curriculum-plus-bundle-full-year-8-escape-rooms' },
    bundle_mega: { placement: 'bundle_comparison', path: '/products/high-school-physics-curriculum-mega-bundle-full-year-22-labs-8-escape-rooms' },
    bundle_compare_all: { placement: 'bundle_comparison', path: '/collections/full-year-curriculum' },
    bundle_help: { placement: 'bundle_comparison', path: '/pages/contact-us' },
    announcement_free: { placement: 'announcement', path: '/pages/free-circuits-escape-room' },
    header_free_drawer: { placement: 'header_drawer', path: '/pages/free-circuits-escape-room' },
    final_free: { placement: 'final_offer', path: '/pages/free-circuits-escape-room' },
    header_free_desktop: { placement: 'header_desktop', path: '/pages/free-circuits-escape-room' },
    header_free_mobile: { placement: 'header_mobile', path: '/pages/free-circuits-escape-room' },
    footer_free: { placement: 'footer', path: '/pages/free-circuits-escape-room' }
  });

  function diagnostic(state, ctaId) {
    // Invisible, controlled DOM diagnostics for deployment QA; no user fields.
    document.documentElement.setAttribute('data-pp-home-cta-status', state);
    if (ctaId) document.documentElement.setAttribute('data-pp-home-cta-last', ctaId);
  }

  function analyticsAllowed() {
    try {
      return Boolean(window.Shopify && window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === 'function' &&
        window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true);
    } catch (error) {
      return false;
    }
  }

  function cleanPageUrl() {
    return window.location.origin + normalizedPath(window.location.pathname);
  }

  function refreshCollectorDiagnostics() {
    document.documentElement.setAttribute('data-pp-home-cta-gtag-type', typeof window.gtag);
    document.documentElement.setAttribute('data-pp-home-cta-consent', analyticsAllowed() ? 'true' : 'false');
  }

  function cleanReferrer() {
    try {
      var ref = new URL(document.referrer);
      if (ref.protocol !== 'https:' && ref.protocol !== 'http:') return '';
      if (ref.origin !== window.location.origin) return '';
      var path = normalizedPath(ref.pathname);
      var known = ['/', '/pages/about-us', '/pages/faq', '/policies/refund-policy'].indexOf(path) !== -1;
      Object.keys(ALLOWED).forEach(function (id) {
        var spec = ALLOWED[id];
        if (!spec.origin && spec.path === path) known = true;
      });
      // Known public same-store paths only; no account/order/provider URLs.
      return known ? ref.origin + path : '';
    } catch (error) {
      return '';
    }
  }

  function qaRequested() {
    try {
      return new URLSearchParams(window.location.search).get('pp_measurement_qa') === '1';
    } catch (error) {
      return false;
    }
  }

  function tagAdditionalButtons() {
    var tags = [
      ['[id$="__announcement-bar"] a[href="/pages/free-circuits-escape-room"]', 'announcement_free'],
      ['a.pp-header-free[href="/pages/free-circuits-escape-room"]', 'header_free_desktop'],
      ['.pp-header-mobile-offer a[href="/pages/free-circuits-escape-room"]', 'header_free_mobile'],
      ['#NavDrawer a[href="/pages/free-circuits-escape-room"]', 'header_free_drawer'],
      ['[id$="__teacher_next_step"] a[href="/pages/free-circuits-escape-room"]', 'final_free'],
      ['[id$="__teacher_bestsellers"] a[href="/collections/teacher-bestsellers"]', 'bestsellers_view_all'],
      ['[id$="__founder_credibility"] a[href="/pages/about-us"]', 'founder_story']
    ];
    tags.forEach(function (entry) {
      document.querySelectorAll(entry[0]).forEach(function (anchor) {
        anchor.setAttribute('data-pp-home-cta', entry[1]);
      });
    });
  }

  function loadPrivacyApi() {
    if (window.Shopify && !window.Shopify.customerPrivacy &&
        typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], function () {
        refreshCollectorDiagnostics();
      });
    }
  }

  function onClick(event) {
    refreshCollectorDiagnostics();
    if (event.isTrusted !== true) return;
    if (typeof event.button === 'number' && event.button !== 0) return;
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var anchor = target.closest('a[data-pp-home-cta]');
    if (!anchor || anchor.getAttribute('aria-disabled') === 'true') return;
    var ctaId = anchor.getAttribute('data-pp-home-cta');
    if (!Object.prototype.hasOwnProperty.call(ALLOWED, ctaId)) return;
    var spec = ALLOWED[ctaId];
    var destination;
    try { destination = new URL(anchor.href, window.location.origin); }
    catch (error) { return; }
    var expectedOrigin = spec.origin || window.location.origin;
    if (destination.origin !== expectedOrigin ||
        normalizedPath(destination.pathname) !== spec.path) {
      diagnostic('skipped-destination-mismatch', ctaId);
      return;
    }
    if (!analyticsAllowed()) {
      diagnostic('skipped-consent', ctaId);
      return;
    }
    if (typeof window.gtag !== 'function') {
      diagnostic('collector-unavailable', ctaId);
      return;
    }
    var qa = qaRequested();
    var params = {
      send_to: GA4_ID,
      cta_id: ctaId,
      cta_placement: spec.placement,
      target_host: new URL(expectedOrigin).hostname,
      target_path: spec.path,
      page_location: cleanPageUrl(),
      page_referrer: cleanReferrer(),
      qa_mode: qa ? '1' : '0',
      transport_type: 'beacon'
    };
    if (qa) params.debug_mode = true;
    try {
      window.gtag('event', EVENT_NAME, params);
      diagnostic('collector-invoked', ctaId);
    } catch (error) {
      diagnostic('collector-error', ctaId);
    }
  }

  // One click listener; no pointer/submit duplicates, navigation interception,
  // input listeners, localStorage, or late replay after a consent change.
  tagAdditionalButtons();
  loadPrivacyApi();
  document.addEventListener('click', onClick);
  document.addEventListener('visitorConsentCollected', refreshCollectorDiagnostics);
  window.addEventListener('load', refreshCollectorDiagnostics, { once: true });
  refreshCollectorDiagnostics();
  diagnostic('ready');
})();
